export default __webpack_public_path__ + "static/toolshub-fa5abcadd9d694157edb7fa53b291d8b.png";